import { useAppUIModal } from '@/contexts/AppUIModalContext'
import { useSiteSpecificContext } from '@/contexts/SiteSpecificContext'

export function useContactUs() {
  const { plan } = useSiteSpecificContext()
  const { canPayModify } = plan
  const { contactUsModal } = useAppUIModal()

  const shouldShowContactUsModal = ({
    action,
  }: {
    action: 'upgrade' | 'cancel'
  }) => {
    if (!canPayModify) {
      contactUsModal.show({
        action,
      })
      return true
    }
    return false
  }

  return {
    shouldShowContactUsModal,
    canPayModify,
  }
}
